export default {
  ownersBeneficiaries: 'Nom des bénéficiaires',
  ownersHolders: 'Nom des détenteurs',
  fullOwnershipPct: '%. Pleine Propriété',
  usufructPct: '%. Usufruit',
  bareOwnership: '%. Nue-propriété',
  sumTargetOwnershipsError: 'Veuiller saisir une somme égale à {target}',
}
